/**
 * The creatures of the world events (ADR 0050), by biome: the goblin raiders
 * of an invasion (who also waylay the gold cart), the warlord who leads its
 * last wave, the giant who prowls about a village, and the gold cart itself,
 * the same in every biome. Their stat blocks
 * are drawn in `mobs.ts` from one creature of each biome, so a raid on
 * Givrecime is fought at Givrecime's level; only the ids live here, since
 * `biomes.ts` reads the bestiary and cannot be read back from it.
 */
/** The biomes, in `BIOME_IDS` order; a test holds the two lists together. */
export const EVENT_BIOMES = ['meadow', 'forest', 'swamp', 'desert', 'snow'];
export const INVADER_MOB_IDS = [
    'goblin-raider-meadow',
    'goblin-raider-forest',
    'goblin-raider-swamp',
    'goblin-raider-desert',
    'goblin-raider-snow',
];
export const WARLORD_MOB_IDS = [
    'goblin-warlord-meadow',
    'goblin-warlord-forest',
    'goblin-warlord-swamp',
    'goblin-warlord-desert',
    'goblin-warlord-snow',
];
export const GIANT_MOB_IDS = [
    'giant-meadow',
    'giant-forest',
    'giant-swamp',
    'giant-desert',
    'giant-snow',
];
/** The cart a convoy escorts: one body for every biome, nobody's to strike. */
export const GOLD_CART_ID = 'gold-cart';
export const EVENT_MOB_IDS = [
    ...INVADER_MOB_IDS,
    ...WARLORD_MOB_IDS,
    ...GIANT_MOB_IDS,
    GOLD_CART_ID,
];
export function invaderOf(biome) {
    return `goblin-raider-${biome}`;
}
export function warlordOf(biome) {
    return `goblin-warlord-${biome}`;
}
export function giantOf(biome) {
    return `giant-${biome}`;
}
//# sourceMappingURL=event-mobs.js.map